module.exports = __webpack_public_path__ + "img/ration-top.cf825fa3.svg";